import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { updateUserPwdApi } from '@/api/baseApp/user';
import { mapGetters, mapState } from 'vuex';
import getImgUrl from "../../utils/img";
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
import LangSelect from '@/components/LangSelect';
import Search from '@/components/HeaderSearch';
import { changeDeptApi } from '@/api/baseApp/user';
import router, { resetRouter } from '@/router';
import store from '@/store';
import { removeTopic } from '@/utils/auth';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog,
    Screenfull: Screenfull,
    LangSelect: LangSelect,
    Search: Search
  },
  data: function data() {
    var _this = this;
    var checkNewPwd = function checkNewPwd(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      form: {
        password: '',
        newPassword: '',
        checkPassword: ''
      },
      rules: {
        password: [{
          required: true,
          message: '请填写旧密码',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
          message: '8-16位，至少1个大写字母，小写字母和数字',
          trigger: 'blur'
        }],
        checkPassword: [{
          required: true,
          validator: checkNewPwd,
          message: '两次密码输入不一样',
          trigger: 'blur'
        }]
      },
      hostUrl: ''
    };
  },
  created: function created() {
    this.hostUrl = window.location.origin;
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'deptList', 'deptId'])), mapState({
    isPower: function isPower(state) {
      return state.settings.isPower;
    }
  })),
  methods: {
    getImgUrl: getImgUrl,
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
      console.log('11111111111');
      this.$eventHub.$emit('changeAirConditioningbox');
    },
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var HsLogin;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              HsLogin = sessionStorage.getItem('HsLogin');
              if (!(HsLogin === '1')) {
                _context.next = 7;
                break;
              }
              this.$router.push("/sewageLogin?redirect=".concat(this.$route.fullPath));
              sessionStorage.removeItem('HsLogin');
              return _context.abrupt("return");
            case 7:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    deptChange: function () {
      var _deptChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        var _this2 = this;
        var loading, _yield$store$dispatch, roleId, url, accessRoutes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '身份切换中请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // const shrName = this.deptList.find(item => item.id === val)
              // const orgList = {
              //   shrName: shrName.orgName,
              //   orgId: val
              // }
              // console.log(orgList)
              _context3.next = 3;
              return changeDeptApi({
                deptId: val
              });
            case 3:
              _context3.next = 5;
              return store.dispatch('user/getInfo');
            case 5:
              _yield$store$dispatch = _context3.sent;
              roleId = _yield$store$dispatch.roleId;
              url = process.env.VUE_APP_BASE_API;
              if (!(this.hostUrl === 'https://kepler.dlg-tec.com' || this.hostUrl === 'http://121.4.181.11:31001')) {
                _context3.next = 11;
                break;
              }
              _context3.next = 11;
              return store.dispatch('user/getTopic').catch(function (error) {
                removeTopic();
                console.log(error, '.catch()');
              });
            case 11:
              _context3.next = 13;
              return store.dispatch('permission/generateRoutes', roleId);
            case 13:
              accessRoutes = _context3.sent;
              setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return store.dispatch('baseApp/getUserApplication');
                    case 2:
                      // await store.dispatch('user/getDataByOrgIdAndShrName', orgList)
                      _this2.$router.push({
                        path: '/dashboard'
                      });
                      _context2.next = 5;
                      return store.dispatch('tagsView/delAllViews', null, {
                        root: true
                      });
                    case 5:
                      // 重置路由
                      resetRouter();
                      // dynamically add accessible routes
                      router.addRoutes(accessRoutes);
                      loading.close();
                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })), 1000);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deptChange(_x) {
        return _deptChange.apply(this, arguments);
      }
      return deptChange;
    }(),
    handelPwd: function handelPwd() {
      this.dialogFormVisible = true;
    },
    handelDalogClose: function handelDalogClose() {
      this.handelClose('formDalog');
    },
    handelClose: function handelClose(val) {
      if (this.$refs[val] !== undefined) {
        this.$refs[val].resetFields();
      }
      this.dialogFormVisible = false;
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs.formDalog.validate(function (valid) {
        if (valid) {
          updateUserPwdApi(_this3.form).then(function () {
            _this3.$confirm('是否确认修改密码', '提醒', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this3.$store.dispatch('user/logout');
                  case 2:
                    _this3.$router.push("/login");
                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }))).catch(function () {
              console.log('取消修改');
            });
          });
        }
      });
    }
  }
};